import React from 'react'

import blog1 from './../../assets/blogs/blog1.png'
import blog2 from './../../assets/blogs/blog2.png'
import blog3 from './../../assets/blogs/blog3.png'
import blog4 from './../../assets/blogs/blog4.png'
import blog5 from './../../assets/blogs/blog5.png'
import { useParams } from 'react-router-dom'
import { motion } from 'framer-motion';

import mainImg from './../../assets/blogs/blogTop.png'

import calenderIcon from './../../assets/blogs/whiteCalender.svg'

import singleBlog from './../../assets/blogs/singleBlog.png'
import { BsFacebook, BsInstagram, BsLinkedin, BsTwitter } from 'react-icons/bs'


const SingleBlog = () => {
    const params = useParams()
    const blogs = [
        {
            id: 1,
            image: blog1,
            url: "/blogs/1",
            date_day: "08",
            date_month: "March",
            title: "Inland freight a worthy solution for your business",
            paragraph: "We are dedicated in creating added value for our customers by implementing modern technology in our work. ",
            props: [
                "Urgent transport solutions",
                "Reliable & experienced staffs",
                "Urgent transport solutions",
                "Reliable & experienced staffs"
            ],
        },
        {
            id: 2,
            image: blog2,
            url: "/blogs/2",
            date_day: "12",
            date_month: "March",
            title: "How technology can help redraw the supply chain map",
            paragraph: "We are dedicated in creating added value for our customers by implementing modern technology in our work. ",
            props: [
                "Urgent transport solutions",
                "Reliable & experienced staffs",
                "Urgent transport solutions",
                "Reliable & experienced staffs"
            ],
        },
        {
            id: 3,
            image: blog3,
            url: "/blogs/3",
            date_day: "25",
            date_month: "March",
            title: "Five things you should have ready for your broker",
            paragraph: "We are dedicated in creating added value for our customers by implementing modern technology in our work. ",
            props: [
                "Urgent transport solutions",
                "Reliable & experienced staffs",
                "Urgent transport solutions",
                "Reliable & experienced staffs"
            ],
        },
        {
            id: 4,
            image: blog4,
            url: "/blogs/4",
            date_day: "28",
            date_month: "March",
            title: "Four simple tips for becoming a healthier truck driver",
            paragraph: "We are dedicated in creating added value for our customers by implementing modern technology in our work. ",
            props: [
                "Urgent transport solutions",
                "Reliable & experienced staffs",
                "Urgent transport solutions",
                "Reliable & experienced staffs"
            ],

        },
        {
            id: 5,
            image: blog5,
            url: "/blogs/5",
            date_day: "30",
            date_month: "March",
            title: "What Is The Role Of A Logistics Operations Manager",
            paragraph: "We are dedicated in creating added value for our customers by implementing modern technology in our work. ",
            props: [
                "Urgent transport solutions",
                "Reliable & experienced staffs",
                "Urgent transport solutions",
                "Reliable & experienced staffs"
            ],
        },
    ]
    const [blog] = blogs.filter((blog) => blog.id.toString() === params.blogId.toString())
    return (
        <div>
            <div className="section_1 min-h-[50vh] bg-cover bg-no-repeat" style={{ backgroundImage: `url("${mainImg}")` }}>
                <div className="layer bg-gradient-to-r min-h-[50vh] from-dark-navy to-transparent flex items-center justify-content ">
                    <motion.div
                        initial={{
                            x: -200,
                            opacity: 0
                        }}
                        whileInView={{
                            x: 0,
                            opacity: 1
                        }}
                        transition={{
                            duration: 0.5
                        }}
                        viewport={{
                            once: true
                        }}
                        className="what-we-do col-span-3 lg:col-span-1 m-auto  w-5/6 lg:w-4/6">
                        <div className="calender xxs:pe-5 xxs:text-center flex gap-5 text-white mt-16">
                            <img src={calenderIcon} alt="" className='' />
                            <div className="">
                                <p className='text-4xl font-semibold'>{blog.date_day}</p>
                                <p className='text-sm font-medium font-Krub'>{blog.date_month}</p>
                            </div>
                        </div>
                        <h2 className="text-3xl md:text-6xl text-white font-semibold my-3">{blog.title}</h2>
                    </motion.div>
                </div>
            </div>
            <div className="section_2">
                <div className="w-5/6 md:w-4/6 lg:w-1/2 m-auto py-16">
                    <h3 className="text-4xl text-dark font-semibold">Your Logistics Solutions</h3>
                    <p className="text-gray text-sm font-Krub font-medium my-3">Duis semper lacus scelerisque, aliquam leo quis, porttitor leo. Etiam lobortis dapibus libero vel porttitor. Nulla tempor elit nec feugiat tempus.Phasellus at quam hendrerit semper feugiat id nunc. Morbi quis justo velit. Duis semper lacus scelerisque, aliquam leo quis, porttitor leo Fusce lectus ex pretium[...]</p>
                    <div className="quote bg-main-light text-white text-center text-xl italic px-5 sm:px-10 py-16 my-5">
                        <p>“Digitization within transport and logistics means seamless service to our customers, visibility in the supply chain, and driving a more efficient business.”</p>
                    </div>
                    <h3 className="text-4xl text-dark font-semibold">Safest Logistics Solutions Provider With Integrity</h3>
                    <p className="text-gray text-sm font-Krub font-medium my-3">Duis semper lacus scelerisque, aliquam leo quis, porttitor leo. Etiam lobortis dapibus libero vel porttitor. Nulla tempor elit nec feugiat tempus.Phasellus at quam hendrerit semper feugiat id nunc. Morbi quis justo velit. Duis semper lacus scelerisque, aliquam leo quis, porttitor leo Fusce lectus ex pretium[...]</p>
                    <div className="imd_box">
                        <img src={singleBlog} alt="" />
                        <p className="text-center text-gray text-sm font-medium font-Krub my-2">The Cargo Ship</p>
                    </div>
                    <p className="text-gray text-sm font-Krub font-medium my-3">Duis semper lacus scelerisque, aliquam leo quis, porttitor leo. Etiam lobortis dapibus libero vel porttitor. Nulla tempor elit nec attempus.Phasellus at quam hendrerit semper David Warner nunc. Morbi quis justo velit. Duis semper lacus scelerisque, aliquam leo quis, porttitor leo Fusce lectus ex pretium.
                        <br />
                        <br />
                        Duis semper lacus scelerisque, aliquam leo quis, porttitor leo. Etiam lobortis dapib libero vel porttitor. Nulla tempor elit nec feugiat tempus Phasellus atquam.</p>
                    <div className="flex items-center justify-between gap-3 py-5 border-y-2 mt-5">
                        <div className="icons flex items-center justify-center gap-2">
                            <div className="social_links flex gap-4 text-dark">
                                <a target="_blank" href="/" className="hover:text-gold">
                                    <BsInstagram />
                                </a>
                                <a target="_blank" href="/" className="hover:text-gold">
                                    <BsFacebook />
                                </a>
                                <a target="_blank" href="/" className="hover:text-gold">
                                    <BsTwitter />
                                </a>
                                <a target="_blank" href="/" className="hover:text-gold">
                                    <BsLinkedin />
                                </a>
                            </div>
                        </div>
                        <div className="category text-gray font-Krub font-medium text-sm ">
                            <p>Category : News</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SingleBlog